import {
  View,
  Text,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
} from "react-native";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBottomNavigation,
  showBackButton,
  showBackButtonWithFunction,
  showBottomNavigation,
} from "../../redux/header/headerAction";
import { lighterBlue, white } from "../../colors";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import DoctorChatDetail from "../../components/consultation/DoctorChatDetail";
import ChatInput from "../../components/consultation/ChatInput";
import VoiceMessage from "../../components/consultation/chatMessage/VoiceMessage";
import TextMessage from "../../components/consultation/chatMessage/TextMessage";
import ImageMessage from "../../components/consultation/chatMessage/ImageMessage";
import { FlatList } from "react-native-gesture-handler";
import detailConsultationUser from "../../api/consultation/detailConsultationUser";
import getChatMessages from "../../api/consultation/getChatMessages";
import { io } from "socket.io-client";
import getToken from "../../api/token";
import getMessages from "../../api/support/getMessages";
import SupportChatInput from "../../components/consultation/SupportChatInput";

export default function Support({ route }) {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fcfcfc"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
      dispatch(hideBottomNavigation());
    }
    return () => {
      dispatch(showBottomNavigation());
    };
  }, [isFocused]);

  const [chat, setChat] = useState([]);

  useEffect(() => {
    const socket = io("https://api.asqtest.ir");
    socket.connect();

    socket.on("connect", (message) => {
      socket.emit("connectedUser", { token: getToken() });
    });

    socket.on("newTicket", (message) => {
      getMessages()
        .then(({ data }) => {
          if (data.status === 200) {
            setChat(data.data);
          }
        })
        .catch((err) => {});
    });
    return () => {
      socket.close("newTicket");
    };
  }, []);
  useEffect(() => {
    getMessages()
      .then(({ data }) => {
        if (data.status === 200) {
          setChat(data.data);
        }
      })
      .catch((err) => {});
  }, []);
  const ChatMessageTypeComponent = (props) => {
    if (props.type === "text") {
      return <TextMessage {...props} />;
    } else if (props.type === "audio") {
      return <VoiceMessage {...props} />;
    } else if (props.type === "image") {
      return <ImageMessage {...props} />;
    } else {
      <></>;
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : ""}
        style={{ height: "100%" }}
        keyboardVerticalOffset={90}
      >
        <View
          style={{
            backgroundColor: "#fff",
            width: "100%",
            alignItems: "center",
            flex: 1,
            paddingBottom: Platform.OS !== "web" ? 30 : 5,
          }}
        >
          <View style={{ flex: 1, width: "100%" }}>
            <FlatList
              inverted
              data={chat}
              ListHeaderComponent={<View style={{ height: 50 }}></View>}
              renderItem={({ item }) => (
                <ChatMessageTypeComponent
                  type={item.type}
                  value={item.value}
                  uri={item.value}
                  sender={item.sender}
                  meSender={item.sender === "patient"}
                  status={item.isread ? "read" : "notRead"}
                />
              )}
            />
          </View>
          <View
            style={{
              width: "100%",
              zIndex: 100,
              backgroundColor: white,
              paddingVertical: 5,
            }}
          >
            <SupportChatInput />
          </View>
        </View>
      </KeyboardAvoidingView>
    </View>
  );
}
